import type { HttpTypes } from '@medusajs/types';

import { PaymentProviderId, PaymentStatus } from '@marxbiotech/shared-types/bff';

import { paymentStatusConfigMap } from '@lib/util/payment-status';
import { StatusLabel } from '@modules/common/components/status-label';

type PaymentStatusConfig = (typeof paymentStatusConfigMap)[PaymentStatus];

export const BasePaymentStatusLabel = ({
  paymentStatusConfig: { description, style },
}: {
  paymentStatusConfig: PaymentStatusConfig;
}) => <StatusLabel color={style}>{description}</StatusLabel>;

type Payment = NonNullable<
  HttpTypes.StorePaymentCollection['payments']
>[number];

export const getPaymentStatusFromPayment = (payment: Payment) => {
  switch (payment.provider_id) {
    case PaymentProviderId.DEPOSIT:
      return PaymentStatus.PAID;
    case PaymentProviderId.COD:
      if (
        Object.entries(payment.data ?? {}).some(
          ([key, value]) =>
            key.startsWith('COD_REQUEST') &&
            (value as { codOutstandingDifference: number })
              .codOutstandingDifference === 0
        )
      ) {
        return PaymentStatus.PAID;
      } else if (
        Object.keys(payment.data ?? {}).some((key) => key.startsWith('COD_PAY'))
      ) {
        return PaymentStatus.PAID;
      } else {
        return PaymentStatus.UNPAID;
      }
    case PaymentProviderId.DEPOSIT_WITH_LOAN:
      if (payment.captured_at) {
        return PaymentStatus.PAID;
      } else {
        return PaymentStatus.UNPAID;
      }
    default:
      return PaymentStatus.PAID;
  }
};

export const PaymentStatusLabel = ({
  order,
}: {
  order: HttpTypes.StoreOrder;
}) => {
  const payment = order.payment_collections?.[0]?.payments?.[0];
  const paymentStatus = payment
    ? getPaymentStatusFromPayment(payment)
    : PaymentStatus.PAID;
  return (
    <BasePaymentStatusLabel
      paymentStatusConfig={paymentStatusConfigMap[paymentStatus]}
    />
  );
};
